module.exports = __webpack_public_path__ + "img/lr-logo.32d9edde.svg";